module.exports = __webpack_public_path__ + "static/media/CL.17ff4928.wav";